import { useEffect, useState } from 'react';

import { LinearProgress } from '@mui/material';
import { useHistory, useParams } from 'react-router-dom';

import { fetchCandidateWithStatus } from 'api';
import { getErrorDetail } from 'helpers';
import { useSnackContext } from 'hooks/useSnackContext';
import { EmployerFullCandidateProps } from 'types';

import { CandidateValidatedWorkPeriods } from './CandidateValidatedWorkPeriods';

export const CandidatePage = () => {
  const { setSnack } = useSnackContext();
  const history = useHistory();
  const { candidate_id } = useParams<{ candidate_id: string }>();
  const [candidate, setCandidate] = useState<EmployerFullCandidateProps | null>(
    null,
  );

  useEffect(() => {
    async function fetchCandidate() {
      try {
        const data = await fetchCandidateWithStatus(parseInt(candidate_id, 10));
        if (data) {
          setCandidate(data);
        }
      } catch (e) {
        // a blank screen with no feedback is bad UX, so display a reason and redirect,
        setSnack((props) => ({
          ...props,
          severity: 'error',
          open: true,
          message: getErrorDetail({
            error: e,
            fallback: 'Failed To Fetch Candidate',
          }),
          error: e as Error,
        }));
        setTimeout(
          () => history.push('/home/employer_dashboard/candidates'),
          3000,
        );
      }
    }
    fetchCandidate();
  }, [candidate_id, history, setCandidate, setSnack]);

  if (!candidate) {
    return <LinearProgress sx={{ width: '100%' }} />;
  }

  return <CandidateValidatedWorkPeriods {...candidate} />;
};
